import React from "react";
import {loadStripe} from "@stripe/stripe-js";
import {Elements} from "@stripe/react-stripe-js";
import StripeCard from "./stripeCard";
import { STRIPE_KEY } from "../../configs";

const stripePromise = loadStripe(STRIPE_KEY);

const StripeCardWrapper = ({show, isUpdate}) => {
    return (
        <Elements stripe={stripePromise}>
            <StripeCard show={show} isUpdate={isUpdate}/>
        </Elements>
    )
}

export default StripeCardWrapper;
